import { createContext, useContext, useState } from 'react';

const DropdownContext = createContext();

export const DropdownProvider = ({ children , options }) => {
  const [selectedPage, setSelectedPage] = useState(options?.[0]);

  return (
    <DropdownContext.Provider value={{ selectedPage, setSelectedPage }}>
      {children}
    </DropdownContext.Provider>
  );
};

export const useDropdown = () => useContext(DropdownContext);